import { CurrencyPipe, I18nPluralPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import { FundraiserDonationComponent } from '../fundraiser-donation/fundraiser-donation.component';

@Component({
  standalone:true,
  selector: 'app-p2p-donor-details-card',
  templateUrl: './p2p-donor-details-card.component.html',
  styleUrl: './p2p-donor-details-card.component.scss',
  providers: [I18nPluralPipe],
  imports:[FundraiserDonationComponent,CurrencyPipe,CoreModule]
})
export class P2pDonorDetailsCardComponent implements OnInit{

  @Input() fundraiser = null;
  @Input() donor = null;
  @Input() index = null;

  @Output() selectedFundraiser = new EventEmitter<any>();

  public fundraiserDonations = [];

  public progressNgStyle = {};
  public image = '';
  public optionName = '';
  public updated = null;
  public progressValue = null;

  constructor() {}

  ngOnInit() {
    this.image = this.fundraiser.profileImage || this.fundraiser.userInfo.image || '/images/org_logo_default_v2.svg';
    this.optionName = this.fundraiser.optionInfo?.name ? this.fundraiser.optionInfo.name : 'other';
    
    const updated = Math.round(new Date(this.fundraiser.updated).getTime()/1000);
    const timestamp = Math.round(new Date().getTime()/1000);
    this.updated = Math.round(timestamp - updated);

    this.progressValue = this.getProgressValue(this.fundraiser.raised, this.fundraiser.goal);
    this.progressNgStyle = {
      width: `${this.progressValue}%`
    }

    // if there is no payer, than donor variable stores transaction object
    let id = this.donor.id || '';
    const payer = this.donor.payer || null;
    if(payer) {
      id = payer.id
    }
    
    const fundraiserTransactions = this.fundraiser.transactions.filter(transaction => transaction.payer.id == id || transaction.id == id);
    const pledges = this.fundraiser.pledges || [];
    const fundraiserPledges = pledges.filter(pledge => pledge.donorInfo.id == id || pledge.donorId == id);

    this.fundraiserDonations = [...fundraiserTransactions, ...fundraiserPledges];
  }

  getProgressValue(raised, goal) {
    if(raised > goal) {
      return 100;
    }
    return (raised/goal) * 100;
  }

  fundraiserSelected() {
    this.selectedFundraiser.emit(this.fundraiser);
  }
}
